"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _debug = _interopRequireDefault(require("debug"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BASE = 'TRS';
var COLOURS = {
  info: '#111e6c',
  warn: '#FDD400',
  error: '#d90000'
};
var environment = process && process.env && process.env.NODE_ENV;
var Log = /*#__PURE__*/_createClass(function Log() {
  var _this = this;
  _classCallCheck(this, Log);
  _defineProperty(this, "startGroup", function (name) {
    return _this.group(name);
  });
  _defineProperty(this, "groupEnd", function () {
    return window.console.groupEnd();
  });
  _defineProperty(this, "generateMessage", function (level, message, source) {
    var namespace = "".concat(BASE, ":").concat(level);
    var createDebug = (0, _debug["default"])(namespace);
    createDebug.color = COLOURS[level];
    if (source) {
      createDebug(source, message);
    } else {
      createDebug(message);
    }
  });
  _defineProperty(this, "info", function (message, source) {
    return _this.generateMessage('info', message, source);
  });
  _defineProperty(this, "warn", function (message, source) {
    return _this.generateMessage('warn', message, source);
  });
  _defineProperty(this, "error", function (message, source) {
    return _this.generateMessage('error', message, source);
  });
  if (!localStorage.getItem('debug') && environment === 'development') {
    localStorage.setItem('debug', "".concat(BASE, ":*"));
  }
  this.group = window.console.groupCollapsed || window.console.group;
});
var _default = new Log();
exports["default"] = _default;